import Vue from 'vue';
import Router from 'vue-router';
import Start from './views/Start.vue';
import WizardStart from './views/WizardStart.vue';
import Error from './views/Error.vue';
import WizardProducts from './views/WizardProducts.vue';
import WizardSelections from './views/WizardSelections.vue';
import Review from './views/Review.vue';
import Checkout from './views/Checkout.vue';
import Confirmation from './views/Confirmation.vue';
import NoResultsFound from './views/NoResultsFound.vue';


Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
      {
          path: '/',
          name: 'start',
          component: Start,
      },
      {
          path: '/wizardStart',
          name: 'wizardStart',
          component: WizardStart,
          props: true
      },
      {
          path: '/wizardProducts',
          name: 'wizardProducts',
          component: WizardProducts,
          props: true
      },
      {
          path: '/wizardSelections',
          name: 'wizardSelections',
          component: WizardSelections,
          props: true
      },
      {
          path: '/review',
          name: 'review',
          component: Review,
          props: true
      },
      {
          path: '/checkout',
          name: 'checkout',
          component: Checkout,
          props: true
      },
      {
          path: '/confirmation',
          name: 'confirmation',
          component: Confirmation,
          props: true
      },
      {
          path: '/error',
          name: 'error',
          component: Error,
          props: true
      },
      {
          path: '/noResultsFound',
          name: 'noResultsFound',
          component: NoResultsFound,
          props: true
      },

  ],
});
